import React from 'react';
import PropTypes from 'prop-types';
import { Step } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * UiStepGroup
 * Display the semantic component Step with the according mode
 * Parameters (Props):
 * @param string id
 * @param bool ordered: A step can show a ordered sequence of steps
 * @param array steps [
 *  string id
 *  bool active: A step can be highlighted as active.
 *  bool completed: A step can show that a user has completed it.
 *  string description
 *  string title
 *]
 * @param string mode
 */
export default class UiStepGroup extends React.PureComponent {
  render() {
    const { id, ordered, steps, mode } = this.props;
    const styleStepGroup = {};
    const styleStep = {};
    const styleActive = {};
    const styleCompleted = {};
    const styleDescription = {};
    const styleTitle = {};
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      /* STEPS_GROUP_BORDER_COLOR,
      STEPS_STEP_COLOR,
      STEPS_STEP_BACKGROUND_COLOR,
      STEPS_STEP_ACTIVE_BACKGROUND_COLOR,
      STEPS_STEP_COMPLETED_ICON_COLOR, */
      styleStepGroup.borderColor = colors.STEPS_GROUP_BORDER_COLOR;
      styleStep.backgroundColor = colors.STEPS_STEP_BACKGROUND_COLOR;
      styleStep.color = colors.STEPS_STEP_COLOR;
      styleDescription.color = colors.STEPS_STEP_COLOR;
      styleTitle.color = colors.STEPS_STEP_COLOR;
      styleActive.backgroundColor = colors.STEPS_STEP_ACTIVE_BACKGROUND_COLOR;
      styleCompleted.color = colors.STEPS_STEP_COMPLETED_ICON_COLOR;
    }

    return (
      <Step.Group ordered={ordered} id={id} style={styleStepGroup}>
        {steps.map((step) => (
          <Step
            id={step.id}
            key={step.id}
            active={step.active}
            completed={step.completed}
            className={`${mode !== null ? 'ui-step' : ''}`}
            style={{
              ...styleStep,
              ...(step.active ? styleActive : {}),
              ...(step.completed ? styleCompleted : {}),
            }}
          >
            <Step.Content>
              {step.title && (
                <Step.Title style={styleTitle}>{step.title}</Step.Title>
              )}
              <Step.Description style={styleDescription}>
                {step.description}
              </Step.Description>
            </Step.Content>
          </Step>
        ))}
      </Step.Group>
    );
  }
}

UiStepGroup.propTypes = {
  id: PropTypes.string,
  ordered: PropTypes.bool,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      active: PropTypes.bool,
      completed: PropTypes.bool,
      description: PropTypes.string,
      title: PropTypes.string,
    })
  ).isRequired,
  mode: PropTypes.string,
};

UiStepGroup.defaultProps = {
  id: '',
  ordered: true,
  mode: null,
};
